module.exports = __webpack_public_path__ + "static/media/pen.4a8de3d3.svg";